import FeedTypeIcon from './FeedTypeIcon'

export default FeedTypeIcon 